// src/pages/PesquisaJurisprudencia/components/FiltersTab.js
import React from 'react';
import { TRIBUNAIS_DISPONVEIS } from '../utils/constants';
import TagSelectionModal from './TagSelectionModal';

const FiltersTab = ({
  tribunaisSelecionados,
  tags,
  selectedTags,
  textoFiltro,
  setTextoFiltro,
  loading,
  loadingTags,
  modalTagsAberto,
  setModalTagsAberto,
  estatisticas,
  handleTribunalChange,
  handleTagsChange,
  handleRemoveTag,
  pesquisar,
  formatarData,
  formatarNumero
}) => {
  return (
    <>
      <div className="filtros-container">
        <div className="filtros-grid">

          {/* Seleção de Tribunais */}
          <div className="campo-grupo">
            <label>Tribunais:</label>
            <div className="tribunais-multiplos">
              {TRIBUNAIS_DISPONVEIS.map(tribunal => (
                <div key={tribunal.value} className="tribunal-checkbox">
                  <input
                    type="checkbox"
                    id={`tribunal-${tribunal.value}`}
                    checked={tribunaisSelecionados.includes(tribunal.value)}
                    onChange={() => handleTribunalChange(tribunal.value)}
                  />
                  <label htmlFor={`tribunal-${tribunal.value}`}>{tribunal.label}</label>
                </div>
              ))}
            </div>
            {estatisticas && tribunaisSelecionados.length > 0 && (
              <div className="tribunal-estatisticas">
                <div className="estatistica-item">
                  📊 Total: {formatarNumero(estatisticas.total_jurisprudencia)} jurisprudências
                </div>
                <div className="estatistica-item">
                  📅 Mais antiga: {formatarData(estatisticas.data_mais_antiga)}
                </div>
              </div>
            )}
          </div>

          {/* Seleção de Tags via Modal */}
          {tribunaisSelecionados.length > 0 && (
            <div className="campo-grupo">
              <label>Tags Jurisprudência:</label>
              <button
                type="button"
                className="botao-selecionar-tags"
                onClick={() => setModalTagsAberto(true)}
                disabled={loadingTags}
              >
                {loadingTags
                  ? '⏳ Carregando tags...'
                  : `🏷️ Selecionar Tags (${selectedTags.length} selecionadas)`}
              </button>

              {selectedTags.length > 0 && (
                <div className="tags-selecionadas">
                  <div className="tags-selecionadas-header">
                    Tags selecionadas ({selectedTags.length}):
                  </div>
                  <div className="tags-badges">
                    {selectedTags.map((tag, index) => (
                      <div key={`selected-${tag}-${index}`} className="tag-badge-removivel">
                        <span className="tag-badge-text">{tag}</span>
                        <button
                          type="button"
                          className="tag-badge-remove"
                          onClick={() => handleRemoveTag(tag)}
                          title="Remover tag"
                        >
                          ✕
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {!loadingTags && tags.length > 0 && (
                <div className="tags-disponveis-info">
                  💡 {formatarNumero(tags.length)} tags disponíveis nos tribunais selecionados
                </div>
              )}
            </div>
          )}

          {/* Pesquisa Full-Text */}
          <div className="campo-grupo">
            <label>Pesquisa por Texto (Full-Text Search):</label>
            <input
              type="text"
              className="campo-texto"
              placeholder="Digite texto para pesquisa avançada em sumário e texto integral..."
              value={textoFiltro}
              onChange={(e) => setTextoFiltro(e.target.value)}
              onKeyPress={(e) => { if (e.key === 'Enter') pesquisar(1); }}
            />
            <small className="texto-ajuda">
              💡 Use aspas para frases exatas, operadores AND/OR para combinações, e * para wildcards
            </small>
          </div>
        </div>

        <button
          className="botao-pesquisar"
          onClick={() => pesquisar(1)}
          disabled={loading || tribunaisSelecionados.length === 0}
        >
          {loading ? 'Pesquisando...' : 'PESQUISAR JURISPRUDÊNCIA'}
        </button>
      </div>

      {/* Modal de Tags — uso exclusivo desta aba */}
      <TagSelectionModal
        isOpen={modalTagsAberto}
        onClose={() => setModalTagsAberto(false)}
        tags={tags}
        selectedTags={selectedTags}
        onTagsChange={handleTagsChange}
        loading={loadingTags}
      />
    </>
  );
};

export default FiltersTab;